export const BLACK = "#000000";
export const WHITE = "#FFFFFF";
export const BLUE_LIGHT = "#50A0C1";
export const BLUE_DARK = "#003D57";
export const BLUE_DARK_TRANSPARENT = "rgba(4, 59, 89, 0.8)";
export const BLUE_TRANSPARENT = "rgba(4, 59, 89, 0.1)";
export const RED = "#ff614f";
export const BLUE = "#236FA0";
export const REGULAR = "Nunito Sans";
